<div class="grid">
  <div class="col-12 md:col-8 md:col-offset-2">
    <div class="card px-6 py-6">
      <p-toast></p-toast>
      <h5>Change password</h5>
      <p class="text-600">Update the password for your account.</p>

      @if (changeForm) {
        <form class="grid p-fluid" [formGroup]="changeForm" (ngSubmit)="submit()">
          <div class="field col-12 md:col-6">
            <label for="oldPassword">Current password</label>
            <p-password
              inputId="oldPassword"
              formControlName="oldPassword"
              [toggleMask]="true"
              [feedback]="false"
              inputStyleClass="w-full"
              styleClass="w-full"
            ></p-password>
            <app-form-error [control]="changeForm.controls.oldPassword" label="Current password" />
          </div>

          <div class="field col-12 md:col-6"></div>

          <div class="field col-12 md:col-6">
            <label for="newPassword">New password</label>
            <p-password
              inputId="newPassword"
              formControlName="newPassword"
              [toggleMask]="true"
              [feedback]="false"
              inputStyleClass="w-full"
              styleClass="w-full"
            ></p-password>
            <app-form-error [control]="changeForm.controls.newPassword" label="New password" />
          </div>

          <div class="field col-12 md:col-6">
            <label for="confirmPassword">Confirm password</label>
            <p-password
              inputId="confirmPassword"
              formControlName="confirmPassword"
              [toggleMask]="true"
              [feedback]="false"
              inputStyleClass="w-full"
              styleClass="w-full"
            ></p-password>
            <app-form-error [control]="changeForm.controls.confirmPassword" label="Confirm password" />
            @if (changeForm.errors?.['passwordsMismatch'] && changeForm.controls.confirmPassword.touched) {
              <small class="error-message">Passwords do not match.</small>
            }
          </div>

          <div class="col-12 flex justify-content-end gap-2 mt-2">
            <button
              type="submit"
              pButton
              pRipple
              [label]="submitting() ? '' : 'Update password'"
              [icon]="submitting() ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
              [disabled]="submitting()"
              class="p-button-success"
            ></button>
          </div>
        </form>
      }
    </div>
  </div>
</div>
